import { render, staticRenderFns } from "./AudienceTableListItemSourceSize.vue?vue&type=template&id=793c08cc"
import script from "./AudienceTableListItemSourceSize.vue?vue&type=script&lang=js"
export * from "./AudienceTableListItemSourceSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports